'use client';

import { useFirebaseAuth } from '@/components/auth/FirebaseAuthProvider';
import Link from 'next/link';

function SupportIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24">
      <path
        d="M12 2.75c4.83 0 8.75 3.32 8.75 7.42 0 2.26-1.18 4.3-3.04 5.67v3.66c0 .3-.31.49-.57.35l-3.2-1.74c-.62.16-1.27.24-1.94.24-4.83 0-8.75-3.32-8.75-7.42S7.17 2.75 12 2.75Zm-2.7 7.42c0 .5.4.9.9.9h3.18c.5 0 .9-.4.9-.9s-.4-.9-.9-.9H10.2c-.5 0-.9.4-.9.9Zm0 3.17c0 .5.4.9.9.9h5.36c.5 0 .9-.4.9-.9s-.4-.9-.9-.9H10.2c-.5 0-.9.4-.9.9Z"
        fill="currentColor"
      />
    </svg>
  );
}

function AccountIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24">
      <path
        d="M12 3.25c2.52 0 4.57 2.05 4.57 4.58 0 2.52-2.05 4.57-4.57 4.57a4.58 4.58 0 0 1 0-9.15Zm0 10.92c4.53 0 8.1 2.31 8.1 5.24 0 .47-.39.84-.85.84H4.75a.84.84 0 0 1-.85-.84c0-2.93 3.57-5.24 8.1-5.24Zm0-9.14a2.89 2.89 0 0 0-2.89 2.88A2.89 2.89 0 0 0 12 10.8a2.89 2.89 0 0 0 2.89-2.89A2.89 2.89 0 0 0 12 5.03Z"
        fill="currentColor"
      />
    </svg>
  );
}

function getInitials(name: string | null | undefined, email: string | null | undefined) {
  const source = name?.trim() || email?.trim() || 'A';
  const words = source.split(/\s+/).filter(Boolean);

  if (words.length >= 2) {
    return `${words[0][0]}${words[1][0]}`.toUpperCase();
  }

  return source.slice(0, 1).toUpperCase();
}

export default function HeaderAuthButtons() {
  const { user, isLoading } = useFirebaseAuth();
  const label = user ? 'Open account' : 'Log in';
  const initials = getInitials(user?.displayName, user?.email);
  const href = user ? '/account' : '/login';

  return (
    <>
      <Link
        aria-label="Support"
        className="header-icon-button header-support-button"
        href="/support"
      >
        <SupportIcon />
      </Link>
      <Link
        aria-label={label}
        className={`header-icon-button header-account-button ${user ? 'header-account-authenticated' : ''}`}
        href={href}
      >
        {isLoading ? (
          <span className="header-account-initials">...</span>
        ) : user?.photoURL ? (
          <img
            alt=""
            className="header-avatar-image"
            referrerPolicy="no-referrer"
            src={user.photoURL}
          />
        ) : user ? (
          <span className="header-account-initials">{initials}</span>
        ) : (
          <AccountIcon />
        )}
      </Link>
    </>
  );
}
